export enum PaymentSource {
  Adyen = 'ADYEN',
  Amazon = 'AMAZON',
  Affirm = 'AFFIRM',
  Apple = 'APPLE',
  Moda = 'MODA',
  PayPal = 'PAYPAL',
  SiteCredit = 'SITE_CREDIT'
}
